import { useCallback, useMemo, useState } from "react";
import { AUTH_SOURCE } from "../../constants/authSource";
import { useGlobalStore } from "../../context/UserContext/userContext";
import {
  getCreOrganisationById,
  getCreOrganisationLabel,
  getCreOrganisations,
  needsCreOrganisationSelection,
} from "../creOrganisation";

export function useCreOrganisationHeader() {
  const authSource = useGlobalStore((s) => s.authSource);
  const creUser = useGlobalStore((s) => s.creUser);
  const creSelectedOrganisationId = useGlobalStore(
    (s) => s.creSelectedOrganisationId,
  );

  const [switchModalOpen, setSwitchModalOpen] = useState(false);

  const orgs = useMemo(() => getCreOrganisations(creUser), [creUser]);
  const isCre = authSource === AUTH_SOURCE.CRE;
  const needsInitialPick = useMemo(
    () =>
      isCre &&
      needsCreOrganisationSelection(creUser, creSelectedOrganisationId),
    [isCre, creUser, creSelectedOrganisationId],
  );

  const currentOrg = useMemo(
    () => getCreOrganisationById(creUser, creSelectedOrganisationId),
    [creUser, creSelectedOrganisationId],
  );

  const label = currentOrg
    ? getCreOrganisationLabel(currentOrg)
    : "Select organisation";

  const canSwitch = isCre && orgs.length > 1;
  const isVisible = isCre && orgs.length > 0;

  const openSwitchModal = useCallback(() => setSwitchModalOpen(true), []);
  const closeSwitchModal = useCallback(() => setSwitchModalOpen(false), []);

  return {
    isVisible,
    label,
    canSwitch,
    needsInitialPick,
    switchModalOpen,
    openSwitchModal,
    closeSwitchModal,
  };
}
